import React from 'react'
import { Box, Link, Typography } from '@mui/material'
import InsertDriveFileRoundedIcon from '@mui/icons-material/InsertDriveFileRounded'
import { advancedColors } from '../../../theme'
import { MessageAttachment } from '../types'

// `null` while the signed URL loads, or after a failed lookup.
const FileAttachmentRow = ({ attachment }: { attachment: MessageAttachment }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 0.75,
      p: 1,
      borderRadius: 1,
      border: `1px solid ${advancedColors.line}`,
      backgroundColor: advancedColors.surface,
      maxWidth: 240,
    }}
  >
    <InsertDriveFileRoundedIcon fontSize="small" sx={{ color: advancedColors.inkMuted, flexShrink: 0 }} />
    {attachment.downloadURL ? (
      <Link
        href={attachment.downloadURL}
        target="_blank"
        rel="noreferrer"
        variant="body2"
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {attachment.filename}
      </Link>
    ) : (
      <Typography
        variant="body2"
        sx={{ color: advancedColors.inkMuted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {attachment.filename}
      </Typography>
    )}
  </Box>
)

export default FileAttachmentRow
